import React from "react";
import cloudStore from "../store/CloudStore";
import CircularProgress from "@material-ui/core/CircularProgress";
import { useParams } from "react-router-dom";
import Typography from "@material-ui/core/Typography";
import { toast, ToastContainer } from "react-toastify";
import Checkbox from "@material-ui/core/Checkbox";
import { _get, _post } from "../Api";
import FormGroup from "@material-ui/core/FormGroup";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { Button } from "@material-ui/core";
import EmailExport from "../components/ExcelExports/EmailExport";

export default function TakeawayDeliveryMarketing() {
  const params = useParams();
  const taMerchantId = Number.parseInt(params.taMerchantId);
  const taMerchant = cloudStore.merchant?.ta_merchants.find((taMerchant) => taMerchant.id === taMerchantId);
  const taMasterMerchantId = taMerchant?.ta_master_merchant_id;
  const [taMerchantIds, setTaMerchantIds] = React.useState(null);
  const [checkedMerchantIds, setCheckedMerchantIds] = React.useState([]);
  const [emailList, setEmailList] = React.useState(null);

  if (!taMerchant) {
    return (
      <div align="center">
        <CircularProgress color="primary" />
      </div>
    );
  }

  const getMerchants = () =>
    _get(`/nova/ta_master_merchant/${taMasterMerchantId}`)
      .then((res) => {
        const array = res.data.map((object) => object.ta_merchant_id);
        setTaMerchantIds(array);
      })
      .catch((e) => {
        console.log(e);
        // setLoading(false);
        toast.error("Something went wrong.", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      });

  if (taMerchantIds == null && taMasterMerchantId != null) {
    getMerchants();
  }

  const getEmailAdresses = () => {
    setEmailList(null);
    const object = { taMerchantIds: checkedMerchantIds };
    _post("/nova/ta_merchant/marketing/emailaddresses", object)
      .then((res) => {
        const emailSet = new Set();
        res.data.forEach((email) => emailSet.add(email));
        const emailArray = Array.from(emailSet);
        setEmailList(emailArray);
      })
      .catch((e) => {
        console.log(e);
        // setLoading(false);
        toast.error("Something went wrong.", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      });
  };

  const onChangeHandler = (id) => {
    if (checkedMerchantIds.includes(id)) {
      const index = checkedMerchantIds.indexOf(id);
      const newArray = [...checkedMerchantIds];
      newArray.splice(index, 1);
      setCheckedMerchantIds(newArray);
    } else {
      setCheckedMerchantIds([...checkedMerchantIds, id]);
    }
  };

  const checkBoxItems = taMerchantIds?.map((id) => {
    const merchant = cloudStore.merchants.find((merchant) =>
      merchant.ta_merchants.find((ta_merchant) => ta_merchant.id === id)
    );
    const merchantName = merchant.name;
    return (
      <FormControlLabel
        style={{ width: "40%" }}
        key={id}
        control={
          <Checkbox
            checked={checkedMerchantIds.findIndex((checkedMerchantId) => checkedMerchantId === id) >= 0}
            onChange={() => onChangeHandler(id)}
            color="primary"
          />
        }
        label={merchantName}
      />
    );
  });

  return (
    <div style={{ width: "90%" }}>
      <Typography variant="h4">Marketing Email Exports</Typography>
      <Button
        style={{ marginRight: "5px" }}
        size="large"
        variant="contained"
        color="primary"
        onClick={getEmailAdresses}
      >
        Export Email List
      </Button>
      {taMasterMerchantId && (
        <Button
          style={{ marginRight: "5px" }}
          size="small"
          variant="outlined"
          onClick={() => setCheckedMerchantIds(taMerchantIds)}
        >
          Select All
        </Button>
      )}
      {taMasterMerchantId && (
        <Button
          style={{ marginRight: "5px" }}
          size="small"
          variant="outlined"
          onClick={() => setCheckedMerchantIds([])}
        >
          Deselect All
        </Button>
      )}
      {emailList && <EmailExport emailList={emailList} />}
      <FormControl>
        <FormGroup row>{checkBoxItems}</FormGroup>
      </FormControl>
      <ToastContainer
        position="bottom-right"
        autoClose={2000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}
